import React from 'react'
import Header from './Header';
import Courses from './Courses';
import Slogan from './Slogan';
import Methods from './Methods';
import Num from './Num';
import Reviews from './Reviews';
import Footer from './Footer';

function Home() {
    return (
        <>
        <Header/>
        <Courses/>
        <Slogan/>
        <Methods/>        
        <Reviews/>
        <Footer/>

        </>
    )
}

export default Home